import styled from '@tanium/react-emotion-9';
import { css } from '@tanium/style-system';
import Text from 'components/styles/text/Text';

const LargeBoldText = styled(Text)(
  css({
    fontSize: 16,
    fontWeight: 'bold',
  })
);

export default LargeBoldText;
